const texts = {
  "0001" : {
    "en": "Login"
  },
  "0002" : {
    "en": "User",
    "pt-br": "Usuário",
    "es": "Usuario"
  },
  "0003" : {
    "en": "Password",
    "pt-br": "Senha",
    "es": "Contraseña"
  },
  "0004" : {
    "en": "Start",
    "pt-br": "Iniciar",
    "es": "Comienzo"
  },
  "0005" : {
    "en": "Invalid User/Password.",
    "pt-br": "Usuário/Senha inválidos.",
    "es": "Usuario / Contraseña inválidos"
  },
  "0006" : {
    "en": "Deliveries",
    "pt-br": "Entregas",
    "es": "Entregas"
  },
  "0007" : {
    "en": "Sensors",
    "pt-br": "Sensores",
    "es": "Sensores"
  },
  "0008" : {
    "en": "Profile",
    "pt-br": "Perfil",
    "es": "Perfil"
  },
  "0009" : {
    "en": "GPS time",
    "pt-br": "Horário GPS",
    "es": "Horário GPS"
  },
  "0010" : {
    "en": "Latitude",
    "pt-br": "Latitude",
    "es": "Latitud"
  },
  "0011" : {
    "en": "Longitude",
    "pt-br": "Longitude",
    "es": "Longitud"
  },
  "0012" : {
    "en": "Speed",
    "pt-br": "Velocidade",
    "es": "Velocidad"
  },
  "0013" : {
    "en": "Sample Id",
    "pt-br": "Id Amostra",
    "es": "Ejemplo de identificacion"
  },
  "0014" : {
    "en": "Voltage",
    "pt-br": "Voltagem",
    "es": "Voltaje"
  },
  "0015" : {
    "en": "Temperature",
    "pt-br": "Temperatura",
    "es": "Temperatura"
  },
  "0016" : {
    "en": "No scheduled deliveries.",
    "pt-br": "Nenhuma entrega programada.",
    "es": "No hay entregas programadas."
  },
  "0017" : {
    "en": "No sensors.",
    "pt-br": "Nenhum sensor.",
    "es": "No hay sensores."
  },
  "0018" : {
    "en": "Boar Studs",
    "pt-br": "Central",
    "es": "Central"
  },
  "0019" : {
    "en": "Doc.",
    "pt-br": "Doc.",
    "es": "Doc."
  },
  "0020" : {
    "en": "Truck",
    "pt-br": "Veículo",
    "es": "Vehículo"
  },
  "0021" : {
    "en": "Plate",
    "pt-br": "Placa",
    "es": "Placa"
  },
  "0022" : {
    "en": "Exit",
    "pt-br": "Sair",
    "es": "Salida"
  },
  "0023" : {
    "en": "Customer",
    "pt-br": "Cliente",
    "es": "Cliente"
  },
  "0024" : {
    "en": "Address",
    "pt-br": "Endereço",
    "es": "Dirección"
  },
  "0025" : {
    "en": "Deliver",
    "pt-br": "Entregar",
    "es": "Entregar"
  },
  "0026" : {
    "en": "Cancel Delivery",
    "pt-br": "Cancelar Entrega",
    "es": "Cancel Entrega"
  },
  "0027" : {
    "en": "In progress",
    "pt-br": "Em trânsito",
    "es": "En transito"
  },
  "0028" : {
    "en": "Status",
    "pt-br": "Status",
    "es": "Status"
  },
  "0029" : {
    "en": "Delivery",
    "pt-br": "Entrega",
    "es": "Entrega"
  },
  "0030" : {
    "en": "Confirm",
    "pt-br": "Confirmar",
    "es": "Confirmar"
  },
  "0031" : {
    "en": "Yes",
    "pt-br": "Sim",
    "es": "Sí"
  },
  "0032" : {
    "en": "No",
    "pt-br": "Não",
    "es": "No"
  },
  "0033" : {
    "en": "Logout",
    "pt-br": "Sair do aplicativo",
    "es": "Cerrar sesión"
  },
  "0034" : {
    "en": "Confirm delivery?",
    "pt-br": "Confirma Entrega?",
    "es": "¿Confirmar el envío?"
  },
  "0035" : {
    "en": "Vehicle Plate",
    "pt-br": "Placa do Veículo",
    "es": "Placa de vehículo"
  },
  "0036" : {
    "en": "Continue",
    "pt-br": "Continuar",
    "es": "Continuar"
  },
  "0037" : {
    "en": "Name",
    "pt-br": "Nome",
    "es": "Nombre"
  },
  "0038" : {
    "en": "UIN",
    "pt-br": "UIN",
    "es": "UIN"
  },
  "0039" : {
    "en": "Temp.Sensors",
    "pt-br": "Sensores Temperatura",
    "es": "Sensores Temperatura"
  },
  "0040" : {
    "en": "Type",
    "pt-br": "Tipo",
    "es": "Tipo"
  },
  "0041" : {
    "en": "Order",
    "pt-br": "Pedido",
    "es": "Orden"
  },
  "0042" : {
    "en": "Orders",
    "pt-br": "Pedidos",
    "es": "Pedidos"
  },
  "0043" : {
    "en": "Note",
    "pt-br": "Observação",
    "es": "Nota"
  },
  "0044" : {
    "en": "Sensor",
    "pt-br": "Sensor",
    "es": "Sensor"
  },
  "0045" : {
    "en": "Boar Studs",
    "pt-br": "CIA",
    "es": "CIA"
  },
  "0046" : {
    "en": "Done",
    "pt-br": "Entregue",
    "es": "Liberado"
  },
  "0047" : {
    "en": "Do you confirm all orders delivered? <br> This can not be changed.",
    "pt-br": "Confirma todos pedidos entregues? <br> Isto não pode ser alterado.",
    "es": "Confirma todos los pedidos entregados? <br> Esta acción no se puede cambiar."
  },
  "0048" : {
    "en": "Orders {}/{} delivered.",
    "pt-br": "Pedidos {}/{} entregues.",
    "es": "Pedidos {} / {} entregados."
  },
  "0049" : {
    "en": "Start Delivery",
    "pt-br": "Iniciar Entrega",
    "es": "Iniciar Entrega"
  },
  "0050" : {
    "en": "Delivery Start",
    "pt-br": "Inicio Entrega",
    "es": "Inicio Entrega"
  },
  "9999":{
    "en": "",
    "pt": "",
    "es": ""
  }
}

export default texts;


// WEBPACK FOOTER //
// ./src/store/texts_i18n.js